export const Footer = () => {
    return (<div className="w-full h-20 pt-2 bg-gray-900 text-center mt-4 text-white text-lg">
        <p>My Beautiful Feet</p>
        <a href="https://www.kelvinaung.com">Portfolio</a>

    </div>)
}